import * as i from "react";
import { c as B, a as g, u as H, b as V } from "./index.stoqs9MZ.js";
import { u as R, c as Z } from "./index.B4ZV02se.js";
import { u as C } from "./index.BUG7NYeV.js";
import { D as q } from "./index.DNGle7LJ.js";
import { h as K, R as U, u as X, F as Y } from "./Combination.r_wXKfB6.js";
import { P as z } from "./index.RcubEhGW.js";
import { P as h } from "./index.TrmYLGk6.js";
import { P as p } from "./index.DMLWxr4u.js";
import { j as s } from "./jsx-runtime.DGlMoOmv.js";
var D = "Dialog", [y, ve] = B(D), [J, u] = y(D), N = (e) => {
  const {
    __scopeDialog: o,
    children: n,
    open: a,
    defaultOpen: r,
    onOpenChange: t,
    modal: l = !0
  } = e, c = i.useRef(null), f = i.useRef(null), [v, x] = H({
    prop: a,
    defaultProp: r ?? !1,
    onChange: t,
    caller: D
  });
  return /* @__PURE__ */ s.jsx(
    J,
    {
      scope: o,
      triggerRef: c,
      contentRef: f,
      contentId: C(),
      titleId: C(),
      descriptionId: C(),
      open: v,
      onOpenChange: x,
      onOpenToggle: i.useCallback(() => x(($) => !$), [x]),
      modal: l,
      children: n
    }
  );
};
N.displayName = D;
var O = "DialogTrigger", I = i.forwardRef(
  (e, o) => {
    const { __scopeDialog: n, ...a } = e, r = u(O, n), t = R(o, r.triggerRef);
    return /* @__PURE__ */ s.jsx(
      p.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": P(r.open),
        ...a,
        ref: t,
        onClick: g(e.onClick, r.onOpenToggle)
      }
    );
  }
);
I.displayName = O;
var _ = "DialogPortal", [Q, j] = y(_, {
  forceMount: void 0
}), w = (e) => {
  const { __scopeDialog: o, forceMount: n, children: a, container: r } = e, t = u(_, o);
  return /* @__PURE__ */ s.jsx(Q, { scope: o, forceMount: n, children: i.Children.map(a, (l) => /* @__PURE__ */ s.jsx(h, { present: n || t.open, children: /* @__PURE__ */ s.jsx(z, { asChild: !0, container: r, children: l }) })) });
};
w.displayName = _;
var m = "DialogOverlay", A = i.forwardRef(
  (e, o) => {
    const n = j(m, e.__scopeDialog), { forceMount: a = n.forceMount, ...r } = e, t = u(m, e.__scopeDialog);
    return t.modal ? /* @__PURE__ */ s.jsx(h, { present: a || t.open, children: /* @__PURE__ */ s.jsx(oe, { ...r, ref: o }) }) : null;
  }
);
A.displayName = m;
var ee = Z("DialogOverlay.RemoveScroll"), oe = i.forwardRef(
  (e, o) => {
    const { __scopeDialog: n, ...a } = e, r = u(m, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ s.jsx(U, { as: ee, allowPinchZoom: !0, shards: [r.contentRef], children: /* @__PURE__ */ s.jsx(
        p.div,
        {
          "data-state": P(r.open),
          ...a,
          ref: o,
          style: { pointerEvents: "auto", ...a.style }
        }
      ) })
    );
  }
), d = "DialogContent", T = i.forwardRef(
  (e, o) => {
    const n = j(d, e.__scopeDialog), { forceMount: a = n.forceMount, ...r } = e, t = u(d, e.__scopeDialog);
    return /* @__PURE__ */ s.jsx(h, { present: a || t.open, children: t.modal ? /* @__PURE__ */ s.jsx(te, { ...r, ref: o }) : /* @__PURE__ */ s.jsx(re, { ...r, ref: o }) });
  }
);
T.displayName = d;
var te = i.forwardRef(
  (e, o) => {
    const n = u(d, e.__scopeDialog), a = i.useRef(null), r = R(o, n.contentRef, a);
    return i.useEffect(() => {
      const t = a.current;
      if (t) return K(t);
    }, []), /* @__PURE__ */ s.jsx(
      b,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: g(e.onCloseAutoFocus, (t) => {
          t.preventDefault(), n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: g(e.onPointerDownOutside, (t) => {
          const l = t.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0;
          (l.button === 2 || c) && t.preventDefault();
        }),
        onFocusOutside: g(
          e.onFocusOutside,
          (t) => t.preventDefault()
        )
      }
    );
  }
), re = i.forwardRef(
  (e, o) => {
    const n = u(d, e.__scopeDialog), a = i.useRef(!1), r = i.useRef(!1);
    return /* @__PURE__ */ s.jsx(
      b,
      {
        ...e,
        ref: o,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (t) => {
          e.onCloseAutoFocus?.(t), t.defaultPrevented || (a.current || n.triggerRef.current?.focus(), t.preventDefault()), a.current = !1, r.current = !1;
        },
        onInteractOutside: (t) => {
          e.onInteractOutside?.(t), t.defaultPrevented || (a.current = !0, t.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const l = t.target;
          n.triggerRef.current?.contains(l) && t.preventDefault(), t.detail.originalEvent.type === "focusin" && r.current && t.preventDefault();
        }
      }
    );
  }
), b = i.forwardRef(
  (e, o) => {
    const { __scopeDialog: n, trapFocus: a, onOpenAutoFocus: r, onCloseAutoFocus: t, ...l } = e, c = u(d, n), f = i.useRef(null), v = R(o, f);
    return X(), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        Y,
        {
          asChild: !0,
          loop: !0,
          trapped: a,
          onMountAutoFocus: r,
          onUnmountAutoFocus: t,
          children: /* @__PURE__ */ s.jsx(
            q,
            {
              role: "dialog",
              id: c.contentId,
              "aria-describedby": c.descriptionId,
              "aria-labelledby": c.titleId,
              "data-state": P(c.open),
              ...l,
              ref: v,
              onDismiss: () => c.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(ne, { titleId: c.titleId }),
        /* @__PURE__ */ s.jsx(se, { contentRef: f, descriptionId: c.descriptionId })
      ] })
    ] });
  }
), E = "DialogTitle", M = i.forwardRef(
  (e, o) => {
    const { __scopeDialog: n, ...a } = e, r = u(E, n);
    return /* @__PURE__ */ s.jsx(p.h2, { id: r.titleId, ...a, ref: o });
  }
);
M.displayName = E;
var F = "DialogDescription", S = i.forwardRef(
  (e, o) => {
    const { __scopeDialog: n, ...a } = e, r = u(F, n);
    return /* @__PURE__ */ s.jsx(p.p, { id: r.descriptionId, ...a, ref: o });
  }
);
S.displayName = F;
var L = "DialogClose", W = i.forwardRef(
  (e, o) => {
    const { __scopeDialog: n, ...a } = e, r = u(L, n);
    return /* @__PURE__ */ s.jsx(
      p.button,
      {
        type: "button",
        ...a,
        ref: o,
        onClick: g(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
W.displayName = L;
function P(e) {
  return e ? "open" : "closed";
}
var k = "DialogTitleWarning", [xe, G] = V(k, {
  contentName: d,
  titleName: E,
  docsSlug: "dialog"
}), ne = ({ titleId: e }) => {
  const o = G(k), n = `\`${o.contentName}\` requires a \`${o.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${o.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${o.docsSlug}`;
  return i.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, ae = "DialogDescriptionWarning", se = ({ contentRef: e, descriptionId: o }) => {
  const a = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${G(ae).contentName}}.`;
  return i.useEffect(() => {
    const r = e.current?.getAttribute("aria-describedby");
    o && r && (document.getElementById(o) || console.warn(a));
  }, [a, e, o]), null;
}, Ce = N, Re = I, he = w, _e = A, Ee = T, Pe = M, ye = S, Ne = W;
const ie = (e, o) => /* @__PURE__ */ s.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ref: o, ...e, children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M18.72 19.78a.75.75 0 1 0 1.06-1.06L13.06 12l6.72-6.72a.75.75 0 0 0-1.06-1.06L12 10.94 5.28 4.22a.75.75 0 0 0-1.06 1.06L10.94 12l-6.72 6.72a.75.75 0 1 0 1.06 1.06L12 13.06l6.72 6.72Z" }) }), Oe = i.forwardRef(ie);
export {
  Ne as C,
  ye as D,
  Oe as F,
  _e as O,
  he as P,
  Ce as R,
  Re as T,
  Ee as a,
  Pe as b
};
//# sourceMappingURL=X24.CNnx-_EL.js.map
